export enum NivelNodoInstitucion {
  NIVEL_INSTITUCION = '0',
  NIVEL_DEPENDENCIA = '1',
  NIVEL_SUBDEPENDENCIA = '2',
  NIVEL_DEPARTAMENTO = '3',
}
